import { useKeycloak } from '@react-keycloak/web';
import { FC, useEffect } from 'react';
import { Outlet } from 'react-router-dom';

import { Box } from '@mui/material';

import AccessDenied from '@/app/ui/AccessDenied/AccessDenied';
import { useAccessDenied } from '@/shared/lib/AccessDeniedContext/AccessDeniedContext';
import { SafeFormProvider } from '@/shared/lib/SafeFormContext/SafeFormContext';
import { NavigationHistoryProvider } from '@/shared/lib/hooks/useNavigationHistory';
import { FullPageLoader } from '@/shared/ui/Loading';

const AuthorizedFullScreenRouters: FC = () => {
  const { keycloak, initialized } = useKeycloak();
  const { denied } = useAccessDenied();

  useEffect(() => {
    if (initialized && !keycloak?.authenticated) {
      keycloak.createLoginUrl({ redirectUri: window.location.href }).then((url: string) => {
        window.location.replace(url);
      });
    }
  }, [keycloak, initialized]);

  if (!initialized || !keycloak?.authenticated) return <FullPageLoader />;
  if (denied) return <AccessDenied />;

  return (
    <NavigationHistoryProvider>
      <SafeFormProvider>
        <Box
          style={{
            display: 'block',
            backgroundColor: '#F4F3F3 !important',
            height: '100vh',
            width: '100vw',
            padding: 0,
            margin: 0,
            overflow: 'hidden',
          }}
        >
          <Outlet />
        </Box>
      </SafeFormProvider>
    </NavigationHistoryProvider>
  );
};

export default AuthorizedFullScreenRouters;
